import { Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { ENROLLMENT_SHARED_USER_TYPES } from "./core/constants/shared.access"; // Create this constant
import { HoldRestrictionGuard } from "./core/guards/hold-restriction.guard";

export const settingsRoute: Routes = [
  {
    path: "settings",
    canActivate: [AuthGuard, HoldRestrictionGuard],
    data: {
      userTypes: ENROLLMENT_SHARED_USER_TYPES || [0, 1, 2, 3, 4, 5, 6, 7, 8],
      moduleId: "personal-info",
    },
    loadComponent: () =>
      import("./common/settings/settings.component").then(
        (m) => m.SettingsComponent,
      ),
    children: [

      {
        path: 'security',
        loadComponent: () => import("./common/settings/security/security.component").then(
          (m) => m.SecurityComponent
        ),
      },
      {
        path: 'refund-policy',
        loadComponent: () => import("./common/settings/refund-policy/refund-policy.component").then(
          (m) => m.RefundPolicyComponent
        ),
      },

      {
        path: "reminder-settings",
        loadComponent: () => import("./common/settings/reminder-settings/reminder-settings.component").then(
          (m) => m.ReminderSettingsComponent
        ),
      },
      {
        path: "penalty-settings",
        loadComponent: () => import("./common/settings/penalty-settings/penalty-settings.component").then(
          (m) => m.PenaltySettingsComponent
        ),
      },

      //   {
      //     path: "mobilephone",
      //     loadComponent: () =>
      //       import("./common/settings/mobile-phone-settings/mobile-phone-settings.component").then(
      //         (m) => m.MobilePhoneSettingsComponent,
      //       ),
      //   },
      {
        path: "twofactorauthentication",
        loadComponent: () =>
          import("./common/settings/two-factor-auth/two-factor-auth.component").then(
            (m) => m.TwoFactorAuthComponent,
          ),
      },


      {
        path: "login-history",
        loadComponent: () =>
          import("./common/settings/login-history/login-history.component").then(
            (m) => m.LoginHistoryComponent,
          ),
      },
    ],
  },
];
